import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import useAlert from "./UseAlert";
import Util from '@/js/common/Util';
import React from "react";

export interface AlertProps {
    title?: string;
    message: string;
    closeText?: string;
    confirmText?: string;
    handleClose?: (...arg: any[]) => any;
    handleConfirm?: (...arg: any[]) => any;
}

const Alert = ({
    title,
    message,
    closeText,
    confirmText,
    handleClose,
    handleConfirm,
}: AlertProps) => {
    const closeBtnRef = React.useRef<HTMLButtonElement>(null);
    const { hideAlert } = useAlert();

    const onClose = () => {
        hideAlert();
        if (handleClose) {
            handleClose();
        }
    };

    const onConfirm = async () => {
        hideAlert();
        if (handleConfirm) {
            await handleConfirm();
        }
    };

    React.useEffect(() => {
        const keydown = (e: any) => {
            if (e.keyCode === 27 || e.keyCode === 32) {
                hideAlert();
            }
        };
        window.addEventListener("keydown", keydown);
        return () => window.removeEventListener("keydown", keydown);
    }, [hideAlert]);

    return (
        <Dialog
            open
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                whiteSpace: "break-spaces",
                ".MuiDialog-root": {
                    // backgroundColor: "#000",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                },
                ".MuiPaper-root": {
                    minWidth: "200px",
                    maxWidth: "100%",
                    width: "auto",
                    borderRadius: "8px"
                },
                ".MuiTypography-root": {
                    position: "relative",
                    boxSizing: "border-box",
                    padding: "0",
                    height: "69px",
                    backgroundColor: "#ffffff",
                    fontFamily: "SpoqaHanSansNeo-Medium",
                    fontSize: "23px",
                    color: "#000000",
                    letterSpacing: "-1.15px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between"
                },
                ".MuiDialogContent-root": {
                    padding: 0
                },
                ".MuiDialogActions-root": {
                    padding: 0,
                    height: "56px"
                },
                ".MuiDialogActions-root>:not(:first-of-type)": {
                    marginLeft: 0
                }
            }}
        >
            <DialogTitle id="alert-header">
                <div className="pt10 pl40 pr40">
                    <span className="fm-c fc333333 fs22">{title ? title : "알림"}</span>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="pl40 pr40 pb40 pt20 mw200 dpFlx aiC">
                    <span className="fm-b fs16 ls08 fc666666 lh22">
                        {message}
                    </span>
                </div>
            </DialogContent>
            <DialogActions>
                <button
                    ref={closeBtnRef}
                    className={
                        "flx1 h100p csP dpFlx aiC jcC bdN " +
                        (Util.isNotEmpty(confirmText) ? "bgcF0F0F0" : "bgc1a8cff")
                    }
                    onClick={onClose}
                >
                    <span
                        className={
                            "fm-c fs16 ls06 " +
                            (Util.isNotEmpty(confirmText) ? "fc222222" : "fcWhite")
                        }
                    >
                        {Util.isEmpty(closeText) ? "닫기" : closeText}
                    </span>
                </button>
                {Util.isNotEmpty(confirmText) ? (
                    <button
                        className="flx1 h100p bgc1a8cff csP dpFlx aiC jcC bdN"
                        onClick={onConfirm}
                    >
                        <span className="fm-c fs16 fcWhite">
                            {confirmText}
                        </span>
                    </button>
                ) : (
                    <></>
                )}
            </DialogActions>
        </Dialog>
    );
};
export default Alert;
